import { render, staticRenderFns } from "./activeTeaDetails.vue?vue&type=template&id=fb2d44ae&scoped=true"
import script from "./activeTeaDetails.vue?vue&type=script&lang=js"
export * from "./activeTeaDetails.vue?vue&type=script&lang=js"
import style0 from "./activeTeaDetails.vue?vue&type=style&index=0&id=fb2d44ae&prod&lang=scss&scoped=true"
import style1 from "./activeTeaDetails.vue?vue&type=style&index=1&id=fb2d44ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2d44ae",
  null
  
)

export default component.exports